import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../LiveLessonReseveContext';
import LiveReserveSubmitConfirm from './confirm/LiveReserveSubmitConfirm';


// 予約ボタン
function LiveReserveSubmit() {

  const {
    formRef, selectedScheduleId, selectedSituation,
  } = useContext(LiveReserveContext);

  const [canReserve, setCanReserve] = useState<boolean>(false);
  const [isDispConfirm, setIsDispConfirm] = useState<boolean>(false);


  useEffect(() => {
    if(selectedScheduleId && selectedSituation) {
      setCanReserve(true);
    } else {
      setCanReserve(false);
    }
  }, [selectedScheduleId, selectedSituation])


  const onPress = () => {
    if(canReserve) {
      // 予約確認
      setIsDispConfirm(true);
    } else {
      // 予約不可→formへスクロール
      formRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }


  return (
    <>
      {/* 予約ボタン */}
      <div className="text-center">
        <button
          type="button"
          className="btn btn-success btn_customize btn_lg"
          style={{
            width: '80%',
            fontSize: '130%',
            letterSpacing: '0.05em',
            ...( !canReserve
              ? { backgroundColor: '#7d7d7d' }
              : {}
            )
          }}
          onClick={onPress}
        >
          予約する <i className="fas fa-chevron-circle-right"></i>
        </button>
      </div>

      {/* 確認モーダル */}
      <LiveReserveSubmitConfirm
        isDispConfirm={isDispConfirm}
        setIsDispConfirm={setIsDispConfirm}
      />
    </>
  );
}
  
export default LiveReserveSubmit;